import { PropertiesSettings, PropertiesOptions } from 'src/types/Main'
import FilteredColorProperty from './filteredColorProperty'
import { translateString } from '../../utils/translateString'
import { useCallback } from 'react'

interface Props {
  appliedProperties: Record<string, string[]>;
  properties: PropertiesSettings[];
  handlesApply: (
    paramsTags: Record<string, string[]> | null,
    paramsProperties: Record<string, string[]> | null,
    paramsSort: string | null,
    paramsMinPrice: number | null,
    paramsMaxPrice: number | null
  ) => void;
}

const FilteredProperties = (props: Props) => {
  const { appliedProperties, properties, handlesApply } = props

  const propertiesStyles = properties.reduce((accumulator: Record<string, string>, property) => {
    accumulator[property.property] = property.style
    return accumulator
  }, {})

  const propertiesOptions = properties.reduce((accumulator: Record<string, PropertiesOptions[]>, property) => {
    accumulator[property.property] = property.options
    return accumulator
  }, {})

  const removeProperty = useCallback((propertyToRemove: string, propertyIndex: string) => {
    const newAppliedProperties = { ...appliedProperties }

    if (newAppliedProperties[propertyIndex]) {
      newAppliedProperties[propertyIndex] = newAppliedProperties[propertyIndex].filter((property) => property !== propertyToRemove)

      if (newAppliedProperties[propertyIndex].length === 0) {
        delete newAppliedProperties[propertyIndex]
      }
    }

    handlesApply(null, newAppliedProperties, null, null, null)
  }, [appliedProperties, handlesApply])

  return (
    <>
      {Object.entries(appliedProperties).map(([propertyIndex, values]) => (
        <div key={propertyIndex} className="filtered-properties filtered-type">
          {propertiesStyles[`${propertyIndex}`] === 'colors'
            ? <FilteredColorProperty
                propertyIndex={propertyIndex}
                values={values}
                propertiesOptions={propertiesOptions}
                removeProperty={removeProperty}
              />
            : (
                values.map((property) => (
                  <div key={property} className="filtered-item">
                    <div>{`${translateString(property)}`}</div>
                    <button aria-label={`Limpar filtro de propriedade: ${translateString(property)}`} className="filtered-items-button-clear" onClick={() => removeProperty(property, propertyIndex)}></button>
                  </div>
                ))
              )}
        </div>
      ))}
  </>
  )
}

export default FilteredProperties
